import React from 'react';
import { Container } from 'react-bootstrap';
import youssefPic from '../assets/youssef_nn.jpg';
import PageHeading from './PageHeading';

class AboutPage extends React.Component {
  render() {
    return (
      <Container className="Center-column">
        <div className="pg-break"> </div>
        <PageHeading icon="person">About Us</PageHeading>
        <div className="about-founder">
          <img
            className="about-founder-img"
            src={youssefPic}
            alt="Youssef Abdelzaher, Founder of Nature's Nefer"
          />
          <div className="about-founder-copy">
            <h2 className="about-founder-title">Founder and Creator</h2>
            <p className="about-founder-text">
              Meet <strong>Youssef A.</strong>, who put together the recipe for{' '}
              <strong>Nature's Nefer</strong> right in his own kitchen! His goal
              was simple: to create natural, effective products that could solve
              his own hair, beard, and skin needs. It all started with the{' '}
              <strong>H.O.T. (Hot Oil Treatment)</strong>, followed by an organic
              hand cream, as he experimented with ingredients inspired by nature.
              What began as a personal solution soon became a passion for
              creating simple, thoughtfully made products.{' '}
              <strong>Nature's Nefer</strong> was born from the idea that taking
              care of yourself can start with what nature provides.
            </p>
            <p className="about-founder-text">
              <strong>Nature's Nefer</strong> is also inspired by the people and
              world around us. Family and friends have been part of the journey,
              sharing feedback, trying new recipes, and helping turn a kitchen
              experiment into something to share. At its heart,{' '}
              <strong>Nature's Nefer</strong> is about bringing together nature,
              community, and everyday self-care.
            </p>
          </div>
        </div>
      </Container>
    );
  }
}

export default AboutPage;
